// EnergyTabs.js
import React, { useState, useEffect } from 'react';
import PvActionsTab from './tabs/PvActionsTab';
import NoPvActionsTab from './tabs/NoPvActionsTab';
import PvHistoricalTab from './tabs/PvHistoricalTab';
import NoPvHistoricalTab from './tabs/NoPvHistoricalTab';
import { useKeycloak } from '@react-keycloak/web';

const EnergyTabs = ({ view, setView, mockEnergyData, COLORS, data }) => {
    const [mainTab, setMainTab] = useState('actions');
    const [subTab, setSubTab] = useState('pv');
    const { keycloak } = useKeycloak();
    const hasPvAccess = keycloak.hasRealmRole('pv-access');

    // Add this effect to redirect users without PV access
    useEffect(() => {
        // If user doesn't have PV access but is on a PV tab, redirect them
        if (!hasPvAccess && subTab === 'pv') {
            setSubTab('noPv');
        }
    }, [hasPvAccess, subTab]);

    const renderSubTabButtons = () => (
        <div className="flex space-x-2 mb-4">
            {/* Only show PV tab button if user has access */}
            {hasPvAccess && (
                <button
                    className={`px-3 py-1 rounded ${subTab === 'pv' ? 'bg-blue-500 text-white' : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300'}`}
                    onClick={() => setSubTab('pv')}
                >
                    PV
                </button>
            )}
            <button
                className={`px-3 py-1 rounded ${subTab === 'noPv' ? 'bg-blue-500 text-white' : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300'}`}
                onClick={() => setSubTab('noPv')}
            >
                No PV
            </button>
        </div>
    );

    const renderMainTabButtons = () => (
        <div className="flex space-x-4 mb-6 border-b border-gray-300 dark:border-gray-600 pb-2">
            <button
                className={`text-sm font-semibold ${mainTab === 'actions' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 dark:text-gray-400'}`}
                onClick={() => setMainTab('actions')}
            >
                Actions
            </button>
            <button
                className={`text-sm font-semibold ${mainTab === 'historical' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 dark:text-gray-400'}`}
                onClick={() => setMainTab('historical')}
            >
                Historical
            </button>
        </div>
    );

    const renderContent = () => {
        if (mainTab === 'actions') {
            // Only show PV tab if user has access, otherwise default to NoPv
            if (subTab === 'pv') {
                return hasPvAccess
                    ? <PvActionsTab view={view} setView={setView} />
                    : <NoPvActionsTab view={view} setView={setView} />;
            } else {
                return <NoPvActionsTab view={view} setView={setView} />;
            }
        } else {
            // Similarly for historical tabs
            if (subTab === 'pv') {
                return hasPvAccess
                    ? <PvHistoricalTab view={view} setView={setView} mockEnergyData={mockEnergyData} COLORS={COLORS} data={data} />
                    : <NoPvHistoricalTab view={view} setView={setView} mockEnergyData={mockEnergyData} COLORS={COLORS} data={data} />;
            } else {
                return <NoPvHistoricalTab view={view} setView={setView} mockEnergyData={mockEnergyData} COLORS={COLORS} data={data} />;
            }
        }
    };

    return (
        <div className="w-full p-4">
            {renderMainTabButtons()}
            {renderSubTabButtons()}
            {renderContent()}
        </div>
    );
};

export default EnergyTabs;